import { render, staticRenderFns } from "./HomePageData.vue?vue&type=template&id=1cd09d08&scoped=true&"
import script from "./HomePageData.vue?vue&type=script&lang=js&"
export * from "./HomePageData.vue?vue&type=script&lang=js&"
import style0 from "./HomePageData.vue?vue&type=style&index=0&id=1cd09d08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd09d08",
  null
  
)

export default component.exports